
import Auth from "@/lib/common/auth";
import { Component, Vue, Watch } from "vue-property-decorator";
import vuexStore from "@/store/vuex-store";
import { CompanyConfig } from "@/lib/common/acm";
import { isShunfengCompany } from "@/utils/sf";

@Component({})
export default class SideLayout extends Vue {
  hoverIndex = 1;
  currentCompanyId = 0;
  showVirtualAvatarMenu = false;
  currentIndex: number | string = 1; //当前菜单栏  --当前使用

  @Watch("$route", { deep: true })
  changeSideLog() {
    this.activeIt();
  }

  //是否有ats系统 （牛人hr端）
  get isAts() {
    return CompanyConfig.getInstance().openAtsSystem === 1;
  }
  //Aibuilder版
  get isNewAi() {
    return vuexStore.isNewAi;
  }
  //普工版
  get isWorker() {
    return vuexStore.isWorker;
  }
  get version0331() {
    return vuexStore.companyPower.version === "0331";
  }

  get isShunfeng() {
    return isShunfengCompany(this.currentCompanyId);
  }

  showMe(is0331?: string) {
    //旧版只展示旧版
    if (!this.version0331) {
      return !is0331;
    }
    //新版默认展示新版，开启setweb则新旧都展示
    if (this.version0331) {
      if (this.setWeb) {
        return true;
      } else {
        return is0331;
      }
    }
  }

  get showJob() {
    return CompanyConfig.getInstance().closeJobList !== 1;
  }
  get showAiGroup() {
    return CompanyConfig.getInstance().closeAiGroup !== 1;
  }

  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  mounted() {
    this.activeIt();
    const companyConfig = CompanyConfig.getInstance(parseInt(Auth.companyId));
    this.currentCompanyId = parseInt(Auth.companyId);
    this.showVirtualAvatarMenu = companyConfig.showVirtualAvatarMenu == 1;
  }
  //高亮
  activeIt() {
    console.log(this?.$route?.name);
    switch (String(this?.$route?.name)) {
      case "dash":
        this.currentIndex = 1;
        break;
      case "dash-v3":
        this.currentIndex = 21;
        break;
      case "exam-paper":
        this.currentIndex = 2;
        break;
      case "exam-paper-sf":
        this.currentIndex = 33;
        break;
      case "paper-info-sf":
        this.currentIndex = 33;
        break;
      case "question-paper-sf":
        this.currentIndex = 33;
        break;
      case "exam-paper-list-sf":
        this.currentIndex = 33;
        break;
      case "exam-list-v3":
        this.currentIndex = 22;
        break;
      case "exam-candidates":
        this.currentIndex = 22;
        break;
      case "ai-question-store":
        this.currentIndex = 3;
        break;
      case "ai-question-store-sf":
        this.currentIndex = 34;
        break;
      case "question-store":
        this.currentIndex = 3;
        break;
      case "exam-candidate":
        this.currentIndex = 4;
        break;
      case "candidate-list":
        this.currentIndex = 23;
        break;
      case "vir-manual":
        this.currentIndex = 7;
        break;
      case "vir-manage":
        this.currentIndex = 5;
        break;
      case "message-log":
        break;
      case "export-list":
        this.currentIndex = 6;
        break;
      case "vir-export":
        this.currentIndex = 9;
        break;
      case "ats-manager":
      case "ats-detail":
        this.currentIndex = 10;
        break;
      case "ats-candidate":
        this.currentIndex = 11;
        break;
      case "nr-recommend":
        this.currentIndex = 12;
        break;
      case "daka-list":
        this.currentIndex = 13;
        break;
      case "ai-group":
        this.currentIndex = 14;
        break;
      case "message-list":
        this.currentIndex = 17;
        break;
      case "messageTemp-list":
        this.currentIndex = 17;
        break;
      case "template-store":
        this.currentIndex = 18;
        break;
      case "job-list":
        this.currentIndex = 19;
        break;
      case "ai-qa-list":
        this.currentIndex = 27;
        break;
      case "company-config":
        this.currentIndex = 28;
        break;
      case "interview-experiment":
        this.currentIndex = 29;
        break;

      default:
        this.currentIndex = 2; //其余页面目前都是2的子页面
    }
  }

  //跳转
  pathTo(to: any) {
    if (this.$route.path === to) return;
    this.$router.push(to);
  }
  handleOpen(key: any, keyPath: any) {
    console.log(key, keyPath);
  }
  handleClose(key: any, keyPath: any) {
    console.log(key, keyPath);
  }

  goToQuestionStore() {
    if (vuexStore.isNewAi) {
      this.$router.push("/ai-question-store");
    } else {
      this.$router.push("/question-store");
    }
  }

  goToQuestionStoreSf() {
    this.$router.push("/ai-question-store-sf");
  }
}
